import { ExportExcelService } from './shared/services/ExportExcelService';
import { CommonServices } from './shared/services/commonservice.service';
/// <reference types="googlemaps" />
/// <reference types="@types/googlemaps" />
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { TitlecaseDirective } from './shared/directive/titlecase.directive';
import { AgmCoreModule } from '@agm/core';
import { GlobalErrorHandler } from './utils/GlobalErrorHandler';
@NgModule({
  declarations: [
    AppComponent,
    TitlecaseDirective
],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    HttpModule,
    FormsModule

  ],
  providers: [AuthGuard,CommonServices,ExportExcelService],
  bootstrap: [AppComponent]
})
export class AppModule { }
